// extracted by mini-css-extract-plugin
export default {"menuBlock":"MC-z","title":"NC-z","nav":"OC-z","flexCell":"PC-z","facetLink":"QC-z"};